module.exports = {
      id: "follow-gnreach-usage",
      viewBox: "0 0 131 42",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#follow-gnreach",
      toString: function () {
        return this.url;
      }
    }